"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = `
  body {
    margin: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/styled/Body.tsx